export const ORDER = '/order'
export const CONFIG = '/config'
export const SMS = '/sms'
export const POLICY = '/policy'
export const FILE = '/file'
// export const MOCK = '/mock'



// WEBPACK FOOTER //
// ./src/api/base.js